import {getSuffix, getUrlFileName, getFileSizeText} from "./tool";

export const fileExtensionIconType = {
    image: ['.pjp', '.jfif', 'pjpeg', '.avif', '.ico', '.tiff', '.gif', '.svg', '.bmp', '.png', '.xbm', '.jxl', '.jpeg', '.svgz', '.jpg', '.webp'],
    video: ['.mp4', '.avi', '.wmv', '.mpg', '.mpeg', '.mov', '.flv'],
    audio: ['.mp3', '.wav'],
    word: ['.doc', '.docx'],
    excel: ['.xls', '.xlsx'],
    ppt: ['.ppt', '.pptx'],
    pdf: ['.pdf'],
    text: ['.txt']
}

export const getFileTypeIcon = function (path) {
    let extension = path ? getSuffix(path) : '';
    let type = 'unknown';
    if(extension) {
        let keys = Object.keys(fileExtensionIconType);
        for(let i = 0, l = keys.length; i < l; i ++) {
            let key = keys[i];
            let index = fileExtensionIconType[key].indexOf(extension);
            if(index >= 0) {
                type = key;
                break;
            }
        }
    }
    return type;
}

export const getShowFileList = function(value) {
    let file = null;
    if(value) {
        if (typeof value === "string") {
            try {
                file = JSON.parse(value);
            } catch(e) {
                console.error(e)
                file = JSON.split(",").map(url => {
                    return {
                        url
                    }
                });
            }
        } else {
            file = value;
        }
        file.forEach(f => {
            f.fileName = f.name || getUrlFileName(f.url);
            f.sizeText = getFileSizeText(f.size);
            f.type = getFileTypeIcon(f.url);
        });
    }
    return file;
}
